import { render } from "./HeroiconsOutlineFolder.vue?vue&type=template&id=1fcee8fd"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineFolder.vue"]])

export default __exports__